import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { NotificationOutline } from '@eqi-investimentos/icons/web';
import { Button, Flex, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { appConfig } from '@/config/app';
import { PATHS } from '@/config/paths';
import { AuthTemplate } from '@/components/layouts/Auth';

export const UnknowErrorWidget = () => {
  const i18n = useT();
  const router = useRouter();
  return (
    <AuthTemplate
      header={{ title: '' }}
      showFPFloatingButton
      containerProps={{
        maxW: { base: 'full', '2xl': '125rem' },
        p: '2xl',
        pr: 0,
        gap: '2xl',
      }}
    >
      <Flex
        flexDir="column"
        justifyContent="center"
        p="3xl"
        gap="2xl"
        background="background.secondary"
        borderRadius="xs"
      >
        <Flex flexDir="column" justifyContent="center" gap="m">
          <NotificationOutline
            data-testid="alert-icon-circle-filled"
            width={32}
            height={32}
            color="content.brand"
          />
          <Text
            fontSize="lg"
            fontWeight="normal"
            lineHeight="2xl"
            color="content.primary"
          >
            {i18n('screens.maintenance.unknowError.title')}
          </Text>
          <Text
            fontSize="md"
            fontWeight="normal"
            lineHeight="xl"
            color="content.tertiary"
          >
            {i18n('screens.maintenance.unknowError.description')}
          </Text>
        </Flex>

        <Flex gap="5" w="32.8rem">
          <Button
            data-testid="button-go-home"
            variant="solid"
            onClick={() => router.push(PATHS.home)}
            justifyContent="center"
            alignItems="center"
            w="17.0625rem"
            h="2.75rem"
            borderRadius="0.25rem"
            gap={2}
          >
            {i18n(`screens.maintenance.unknowError.goHome`)}
          </Button>
          <Flex
            as={Link}
            href={supportLink}
            target="_blank"
            rel="noopener noreferrer"
            w="17.0625rem"
          >
            <Button
              data-testid="button-get-help"
              variant="outline"
              justifyContent="center"
              alignItems="center"
              w="17.0625rem"
              h="2.75rem"
              borderRadius="0.25rem"
              gap={2}
            >
              {i18n(`screens.maintenance.unknowError.help`)}
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </AuthTemplate>
  );
};

const supportLink = `${appConfig.support.whatsAppUrlBase}?phone=${appConfig.support.number}&text=${appConfig.support.message}`;
